<template>
  <div class="all">
    <Head></Head>
    <div class="ShoppingCart">
      <div class="ShoppingCart_gou">
        <span :class="tab == 1?'aevie':''" @click="gatTab(1)">购物车</span>
        <span :class="tab == 2?'aevie':''">填写订单</span>
        <span :class="tab == 3?'aevie':''" @click="gatTab(3)">完成订单</span>
      </div>
      <div class="ShoppingCart_gou_one" v-if="tab == 1">
        <div class="ShoppingCart_flx">
          <span>商品</span>
          <span>商品信息</span>
          <span>单价</span>
          <span>颜色</span>
          <span>数量</span>
          <span>金额</span>
          <span>操作</span>
        </div>
        <div class="ShoppingCart_for">
          <div class="ShoppingCart_flx1" v-for="(item,key) in shopimg" :key="key">
            <div>
              <img :src="$store.state.Url+item.img" alt="">
            </div>
            <div style="line-height: 18px">
              <span>{{item.goods_name}}</span>
            </div>
            <div>
              <span>{{item.price}}</span>
            </div>
            <div>
              <span>{{item.goods_color_name}}</span>
            </div>
            <div @click="getId(item.id,item.num)">
              <el-input-number v-model="item.num" @change="handleChange" :min="1" :max="99999" label="描述文字"></el-input-number>
            </div>
            <div>
              <p>{{item.price*item.num}}</p>
            </div>
            <div>
              <span @click="getDel(item.id)">移除</span>
            </div>
          </div>
        </div>
        <div class="ShoppingCart_zhifu">
          <div class="ShoppingCart_zhifu1" @click="getAddDing">去填写订单</div>
          <div class="ShoppingCart_zhifu2">￥{{getTotal}}</div>
          <div class="ShoppingCart_zhifu3">已选购 <span>{{getTotalNum}}</span> 种商品</div>
        </div>
      </div>
      <div class="ShoppingCart_gou_two" v-if="tab == 2">
        <div class="MyPoints_form_ul">
          <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;">
            <el-col :span="4">
              <div class="grid-content">收货人</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">手机号</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">省市区</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">详细地址</div>
            </el-col>
            <!--              <el-col :span="4"><div class="grid-content">获取积分数</div></el-col>-->
            <el-col :span="4">
              <div class="grid-content">时间</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">操作</div>
            </el-col>
          </el-row>
          <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;" v-for="(item,index) in DataList"
                  :key="index" v-if="DataList.length>0">
            <el-col :span="4">
              <div class="grid-content">{{item.name}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.phone}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.pro_name}}{{item.city_name}}{{item.area_name}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.add_ress}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content" v-if="item.add_time">{{item.add_time | filterDate('yyyy/MM/dd')}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content" v-if="item.add_time == null"> 暂无</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <el-button type="success" style="border: none;" @click="getSave(item.id)">选择默认地址</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;" v-if="DataList.length<=0">
            <el-col :span="24">
              <div class="grid-content">
                暂无!
                <span> 去添加收货地址 </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="ShoppingCart_gou_two_top">
          <span>收货地址</span>
        </div>
        <div class="ShoppingCart_gou_two_arr">
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="真实姓名">
              <el-input v-model="form.name" style="width: 30%" :disabled='witch'></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="form.phone" style="width: 30%" :disabled='witch'></el-input>
            </el-form-item>
            <el-form-item label="选择地址">
              <el-select v-model="form.pro_id" placeholder="地址" style="width: 15%" :disabled='witch' @change="getCity1(form.pro_id)">
                <el-option :label="item.name" :value="item.id" v-for="(item,key) in city1" :key="key"></el-option>
              </el-select>
              <el-select v-model="form.city_id" placeholder="地址" style="width: 15%" :disabled='witch' @change="getCity2(form.city_id)">
                <el-option :label="item.name" :value="item.id" v-for="(item,key) in city2" :key="key"></el-option>
              </el-select>
              <el-select v-model="form.area_id" placeholder="地址" style="width: 15%" :disabled='witch'>
                <el-option :label="item.name" :value="item.id" v-for="(item,key) in city3" :key="key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="form.add_ress" style="width: 30%" :disabled='witch'></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="witch = false" v-if="witch == true">修改默认地址</el-button>
              <el-button type="primary" @click="getSaveAdes" v-if="witch == false">保存修改</el-button>
              <el-button v-if="witch == false" @click="witch = true">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="ShoppingCart_gou_two_top">
          <span>支付</span>
        </div>
        <div class="ShoppingCart_gou_two_top_rio">
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="支付方式">
              <el-radio-group v-model="radio">
                <el-radio :label="1">月结</el-radio>
                <el-radio :label="2">支付宝</el-radio>
                <el-radio :label="3">微信</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <img src="../assets/wenxin.png" alt="" style="width: 200px" v-if="radio == 3">
        </div>
        <div class="ShoppingCart_gou_two_top">
          <span>货物信息</span>
        </div>
        <div class="ShoppingCart_gou_two_H">
          <span>本订单共:{{getTotalNum}}件商品 总金额：{{getTotal}} 元；</span>
          <el-form ref="form" :model="form" label-width="70px">
            <el-form-item label="订单备注">
              <el-input
                type="textarea"
                :rows="8"
                placeholder="请输入内容"
                v-model="content"
                style="width: 50%"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getAddDan(getTotal)">完成付款并提交订单</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="ShoppingCart_gou_three" v-if="tab == 3">

      </div>
    </div>
    <Pagetail></Pagetail>
  </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getqueryshopping,getdeleteshopping,getListCity,getFinList,getaddorder} from '../api/List'
  import {getCity,getfsaveress} from '../api/Mycen'
  export default {
    name: "ShoppingCart",
    components: {
      Pagetail, Head,
    },
    data() {
      return {
        num:1,
        tab:1,
        //  默认地址修改  参数
        witch:true,
        form: {
          id:'',
          name:'',
          phone: '',
          pro_id: '',
          city_id: '',
          area_id:'',
          add_ress: '',
        },
        // 发票参数
        radio:1,
        Options:"1",  //备选项
        textarea:"",  //备注
        shopimg:[],  //备注
        DataList:[],  //地址列表
        shopId:'',  //单个商品id
        shopnum:'',  //单个商品数量
        city1:[],
        city2:[],
        city3:[],
        content:'', //备注
        city_id:'', //地址ID
      }
    },
    computed: {
      getTotal() {
        let total = 0;
        this.shopimg.forEach(item => {
          total+=parseFloat(item.price) * parseFloat(item.num);
        })
        return total;
      },
      getTotalNum() {
        let totalNum = 0;
        this.shopimg.forEach(item => {
          totalNum+=parseFloat(item.num);
        })
        return totalNum;
      },
    },
    mounted() {
      this.init()
    },
    methods:{
      getSaveAdes(){
        getfsaveress(this.form).then(res=>{
          this.witch = true
        })
      },
      getSave(id){
        this.city_id = id
        getFinList({id:id}).then(res=>{
          this.form = res.result
          this.form.pro_id=String(res.result.pro_id)
          this.form.city_id=String(res.result.city_id)
          this.form.area_id=String(res.result.area_id)
          getCity().then(res=>{
            this.city1 = res.result
            getCity({parentid:this.form.pro_id}).then(res=>{
              this.city2 = res.result
              getCity({parentid:this.form.city_id}).then(res=>{
                this.city3 = res.result
              })
            })
          })
        })
      },
      getAddDing(){
        this.tab = 2
        getListCity().then(res=>{
          this.DataList = res.result
          if (this.DataList.length!==0){
            this.city_id = this.DataList[0].id
            let id = this.DataList[0].id
            getFinList({id:id}).then(res=>{
              this.form = res.result
              this.form.pro_id=String(res.result.pro_id)
              this.form.city_id=String(res.result.city_id)
              this.form.area_id=String(res.result.area_id)
              getCity().then(res=>{
                this.city1 = res.result
                getCity({parentid:this.form.pro_id}).then(res=>{
                  this.city2 = res.result
                  getCity({parentid:this.form.city_id}).then(res=>{
                    this.city3 = res.result
                  })
                })
              })
            })
          }
        })
      },
      getId(id,num){
        this.shopId = id
        this.shopnum = num
      },
      handleChange(value) {
        console.log(value);
        console.log(this.shopimg)
      },
      getDel(id){
        this.$confirm('确定移除购物车吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getdeleteshopping({id:id}).then(res=>{
            this.init()
          })
        }).catch(() => {

        });
      },
      gatTab(ee){
        this.tab  = ee
      },
      init(){
        getqueryshopping({}).then(res=>{
          this.shopimg = res.data
        })
        getCity().then(res=>{
          this.city1 = res.result
        })
      },
      getCity1(id){
        getCity({parentid:id}).then(res=>{
          this.city2 = res.result
          this.form.city_id = ''
          this.form.area_id = ''
        })
      },
      getCity2(id){
        getCity({parentid:this.form.city_id}).then(res=>{
          this.city3 = res.result
        })
      },
      getAddDan(price){
        getaddorder({
          price:price,
          goods_num:this.shopimg.length,
          pay_type:this.radio,
          content:this.content,
          list:this.shopimg,
          city_id:this.city_id,
          // goods_type:1, //1普通商品  2积分商品
        }).then(res=>{
          if(this.radio == 1){
            this.$router.push({path:'/personalCenter',query:{page:1}})
          }else {

          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  @import "css/shopping";
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue